export const OrderIntakeForm = () => import('./OrderIntakeForm').then(({ OrderIntakeForm }) => {
  return {
    Component: OrderIntakeForm
  };
});